const packageConfig = require('../package.json');

const globalConfig = {
  version: packageConfig.version,
  // 小福牛因为部署和前端架构原因 目前仅支持使用 hashHistory
  // 可选值 'browserHistory' | 'hashHistory'
  history: 'hashHistory',
  // 1、使用 browserHistory 项目部署在根目录   可将 package.json  homepage 设置为 .
  // 2、使用 browserHistory 项目部署在非根目录 可将 package.json  homepage 设置为 /目录名/
  // 3、使用 hashHistory，此时和部署目录无关   可将 package.json  homepage 设置为 ./
  basename: packageConfig.homepage,
  // 是否使用vw单位转换, 默认按照375进行转换， 具体配置请修改根目录 craco.config.js
  // 项目重启生效
  enablePx2vw: true,
  // 是否开启项目依赖分析
  // 项目重启生效
  enableBundleAnalyzer: false,
};

module.exports = { globalConfig };
